import $ from 'jquery';
import bootbox from 'bootbox';

import { __ } from 'JIX/gettext.js';

const lang = window.Stash.common.lang;
bootbox.setLocale(lang);

$(function() {

    function openConfirm(e, $el, afterConfirm) {
        e.preventDefault();
        const title         = $el.data('confirm-title');
        const message       = $el.data('confirm-message');
        const label         = $el.data('confirm-accept') || 'OK';
        const confirm_class = $el.data('confirm-class') || 'btn-primary';

        bootbox.confirm({
            message,
            title,
            buttons: { confirm: { label, className: confirm_class } },
            callback: res => {
                if (res) { afterConfirm(); }
            }
        });
    }

    /**
    * Renders bootbox confirm model on all elements with '.btn-click-confirm' class.
    *
    * The message is set with the 'data-confirm-message' attribute.
    * The optional title is set with the 'data-confirm-title' attribute.
    * The optional link target is set with the 'data-confirm-target' attribute.
    *
    * Follows the link on success.
    */

    $(document).on('click', '.btn-click-confirm', function(e) {
        const $el    = $(this);
        const href   = $el.attr('href');
        const target = $el.data('confirm-target');
        openConfirm(e, $el, () => {
            if (target) {
                window.open(href, target);
            } else {
                window.location.href = href;
            }
        });
    });

    /**
    * Renders bootbox confirm model on all elements with '.btn-form-confirm' class.
    *
    * The mesaage is set with the 'data-confirm-message' attribute.
    * The optional title is set with the 'data-confirm-title' attribute.
    *
    * Submits the nearest form on success.
    */

    $(document).on('click', '.btn-form-confirm', function(e) {
        const $el = $(this);
        openConfirm(e, $el, () => {
            // Submit nearest form (same logic as original)
            $el.closest('form').trigger('submit');
        });
    });

    /**
    * Renders bootbox confirm modal for all elements with '.btn-ajax-confirm' class.
    *
    * Submits an AJAX request to the value of 'data-confirm-url' attribute.
    * Alerts with error mesaage on failed AJAX request.
    *
    * Expects JSON response.
    * On true 'success' field, redirects to 'redirect' field if set, otherwise reloads page.
    * Otherwise, alerts value of 'error' field if set.
    */

    $(document).on('click', '.btn-ajax-confirm', function(e) {
        const $el  = $(this);
        const url  = $el.data('confirm-url');
        const csrf = window.Stash.common.csrf_token;

        openConfirm(e, $el, () => {
            $.ajax(url, {
                type: 'POST',
                data: { csrf_token: csrf },
                dataType: 'json',
                success: data => {
                    if (data.success) {
                        if (data.redirect) {
                            window.location.href = data.redirect;
                        } else {
                            location.reload(true);
                        }
                    } else if (data.error) {
                        bootbox.alert(data.error);
                    }
                },
                error: function() {
                    bootbox.alert(__('En fejl opstod i forbindelse med forespørgslen.'));
                }
            });
        });
    });
});


/**
 * Extends jQuery and renders bootbox confirm model on all selected elements - is chainable.
 * @param {function} callback - function that takes boolean; true on 'Ok', false on 'Cancel'.
 *
 * 'this' refers to selected elements in the callback.
 */

$.fn.jix_handle_confirm = function (callback) {
    return this.each(function() {
        $(this).on('click', function(e) {
            e.preventDefault();

            const title   = $(this).data('confirm-title');
            const message = $(this).data('confirm-message');
            const label   = $(this).data('confirm-accept') || 'OK';
            const confirm_class = $(this).data('confirm-class') || 'btn-primary';

            bootbox.confirm({
                message: message,
                title: title,
                buttons: { confirm: { label: label, className: confirm_class } },
                callback: $.proxy(callback, this) // Bind current 'this' instance to callback
            });
        });
    });
};
